import { Button } from "components/Button/Button";
import Datepicker from "components/DatePicker/DatePicker";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useState } from "react";
import { MessageType } from "types/enum";
import {
  FloorWithRoundingPlace,
  RoundWithRoundingPlace,
  trans,
  uuidv4
} from "utils/helpers";
import { ItemsForSell } from "../components/ItemsForSell/ItemsForSell";
import { PriceDetails } from "../components/PriceDetails";
import {
  getPriceListDetail
} from "./api";
import ItemSelector from "./components/SalesInvoiceDetail/ItemSelector";
import PriceFields from "./components/SalesInvoiceDetail/PriceFields";
import { SalesInvoiceDetailType } from "./type";
import { WarehouseTreeForm } from "./components/WarehouseTreeForm/WarehouseTreeForm";
import { PriceInput } from "components/PriceInput/PriceInput";
import { ItemStockList } from "pages/InventoryAndSales/Inventory/WarehouseIO/components/ItemStockList";

interface SalesInvoiceFormProps {
  onHide: () => void;
  SalesInvoiceDetailCallBack?: (e: any) => void;
  selectedObj?: any;
  docsClassification?: any;
  mode: any;
  priceList?: any;
  lastWarehouse?: any;
  invoiceConstraint?: any;
  setLastWarehouse: (e: any) => void;
  personId?:any;
  currency?:any
  SalesInvoiceId?:any
  initialStock?:number
  jobId?:any
}

export const SalesInvoiceDetailForm = ({
  lastWarehouse = null,
  invoiceConstraint,
  setLastWarehouse,
  priceList,
  selectedObj,
  docsClassification,
  mode,
  onHide,
  SalesInvoiceDetailCallBack,
  personId,
  currency,
  SalesInvoiceId,
  initialStock,
  jobId
}: SalesInvoiceFormProps) => {
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userChanges, setUserChanges] = useState({});

  const [showTree, setShowTree] = useState(false);
  const [showWarehouseTree, setShowWarehouseTree] = useState(false);
  const [priceListDetail, setPriceListDetail] = useState<any>([]);
    const [itemStokList, setItemStokList] = useState<any>();
  const [detailPriceData, setDetailPriceData] = useState<any>({

    Discount: '',
    GrandTotalPrice:'0',
    SubTotalPrice: 0,
    CustomerDiscount: "0",
    TotalPrice: "0",
    TaxRate: "0",
    Qty1: mode !== 'create' ? selectedObj?.Qty1 : 1,
    Qty2: mode !== 'create' ? selectedObj?.Qty2 : 1,
  });
  const [itemData, setItemData] = useState<any>(null);
  const [warehouseData, setWarehouseData] = useState(mode == "create" ? lastWarehouse:null);
  const [dictionaryName, setDictionaryName] = useState<any>({});
  const [loadingItemStock,setLoadingItemStock]=useState(true)
  const [saveExit, setSaveExit] = useState(false);
  const [rate, setRate] = useState<any>(1);
  const [firstQty, setFirstQty] = useState<any>(null);
  const [numberOfSalesUnit, setNumberOfSalesUnit] = useState(1);
  const [showPriceListDetail,setShowPriceListDetail]=useState<any>(false)
  const [savedNewQty,setSavedNewQty]=useState(null)
  const [editedNewId,setEditedNewId]=useState<any>(false)//در مد ادیت اگر اتم عوض شود باید ایدی سطر را عوض کنیم که بک اند مشکل نخورد

    const [itemSearch, setItemSearch] = useState<any>("");


  
  const handleSalesInvoiceFormSubmit = async (event) => {
    event.preventDefault();
    const data: SalesInvoiceDetailType = {
     Id: mode !== "create" ?editedNewId? selectedObj?.Id+'changeId': selectedObj?.Id : uuidv4(),

      SalesInvoiceId: SalesInvoiceId,
      SourceId: selectedObj?.ItemId==detailPriceData?.ItemId ? selectedObj?.SourceId:undefined,
      SourceData:selectedObj?.ItemId==detailPriceData?.ItemId  ? selectedObj?.SourceData:undefined,
      // IsAbsoluteUnitConversionRatio	: selectedObj.IsAbsoluteUnitConversionRatio	,
      ItemId: itemData?.ItemId,
      WarehouseId: warehouseData?.WarehouseId,
      WarehouseDetailId: warehouseData?.WarehouseDetailId,
      Unit1Id: event.target.Unit1Id?.value || null,
      Unit2Id: event.target.Unit2Id?.value || null,
      SalesUnitId: detailPriceData.SalesUnitId,
      ItemCode: itemData?.Code?itemData?.Code:itemData?.ItemCode,
      Item: itemData?.Item ,
      Qty1: +event.target.Qty1?.value,
      Unit1: dictionaryName?.Unit1 || null,
      Qty2: +event.target.Qty2?.value,
      Unit2: dictionaryName?.Unit2 || null,
      SalesUnitPrice: detailPriceData.SalesUnitPrice,
      ConversionRatio: rate,
  



          HasExpireDate:
      itemData?.HasExpireDate,
        HasProductTracking:
       itemData?.HasProductTracking,
        
        HasSerial: 


itemData?.HasSerial,
      

      CustomerDiscount: event.target.CustomerDiscount? +event.target.CustomerDiscount.value.replaceAll(",", ""):0,
      Unit1Price:numberOfSalesUnit===1?detailPriceData.SalesUnitPrice:parseFloat(event.target.Unit1Price?.value.replace(/,/g, '')),
      Unit2Price:numberOfSalesUnit===2?detailPriceData?.SalesUnitPrice:parseFloat(event.target.Unit2Price?.value.replace(/,/g, '')),
      
      SubTotalPrice:event.target.SubTotalPrice?.value? parseFloat(event.target.SubTotalPrice?.value.replace(/,/g, '')):0,
      DiscountPercent:parseFloat(event.target.DiscountPercent?.value.replace(/,/g, '')),
      Discount: parseFloat(event.target.Discount?.value.replace(/,/g, '')),
     
      Tax: ((docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& ((mode!='view' && invoiceConstraint.HasTax) || mode=='view' ))) ? parseFloat(event.target.Tax?.value.replace(/,/g, '')): 0),

      TotalPrice: parseFloat(event.target.TotalPrice?.value.replace(/,/g, "")),
      GrandTotalPrice: +event.target.GrandTotalPrice.value.replaceAll(",", ""),
     
      CustomerDiscountPercent:event.target.CustomerDiscountPercent ? +event.target.CustomerDiscountPercent.value.replaceAll(",", ""):0,
      TaxRate:((docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& ((mode=='create' && invoiceConstraint.HasTax) || mode!='create' ))) ?priceListDetail[0].TaxRate: 0),
      ItemTechnicalCode: event.target.ItemTechnicalCode?.value,
      PartyNo: itemStokList?.PartyNo?itemStokList?.PartyNo:null,
      ExpireDate: itemStokList?.ExpireDate,
      CargoWeight: +event.target?.CargoWeight?.value || 0,
      Description: event.target.Description?.value,
      Warehouse: warehouseData.WarehouseTitle,
      WarehouseDetail: warehouseData?.WarehouseDetail,
      Qty1RoundingPlace:priceListDetail[0]?.Qty1RoundingPlace,
      Qty2RoundingPlace:priceListDetail[0]?.Qty2RoundingPlace,
      IsAbsoluteUnitConversionRatio:priceListDetail[0]?.IsAbsoluteUnitConversionRatio 
    };


    SalesInvoiceDetailCallBack?.(data) && resetFormIfNeeded()
    setLastWarehouse(warehouseData);
    // SalesInvoiceDetailCallBack?.(data) ;
  };

  const resetFormIfNeeded = () => {
    if (mode === 'create') {
      setResetForm(true);
      setItemData(null);
      setUserChanges({});
      setDetailPriceData({ 
        CustomerDiscount: 0,
        TotalPrice:0,
    GrandTotalPrice:0,

        Discount: 0, SubTotalPrice: 0, Qty1: 1, Qty2: 1 , TaxRate: 0 });
      setPriceListDetail([]);
    }
    sessionStorage.setItem('changingforms', 'false');
    if (saveExit) onHide();
  };

  const handleItemCode = (obj, isLeafSelected) => {
    if (obj.IsLeaf || isLeafSelected) {
      setItemData({...obj,ItemId:obj?.Id});
      setSavedNewQty(null)
      fetchPriceListDetail(obj.Id);
      setShowTree(false);
      setDetailPriceData({
        
        Discount: 0,
        CustomerDiscount: 0,
        TotalPrice:0,
        SubTotalPrice: 0,
        TaxRate: 0,
        Qty1:  1,
        Qty2:  1,
    GrandTotalPrice:0,

      });
      if(mode==='edit'){
        setShowPriceListDetail(true)
      }
    } else {
      // Toast('msg_itemleafisnotselected', 'error');
      Toast('msg_itemleafisnotselected', MessageType.error);

    }
  };




  const handleWarehouseSelection = (obj) => {
    setWarehouseData(obj);
    setShowWarehouseTree(false);
  };

  const updateQuantity =async (newQty, priceListArray = [] ,QtyInChange=null) => {
    if ((QtyInChange==null&&priceListDetail[priceListDetail.length - 1].SalesUnitMaxOrderQty)||(QtyInChange=="Qty"+numberOfSalesUnit&&priceListDetail[priceListDetail.length - 1].SalesUnitMaxOrderQty) ) 
      {
        //when we get priceList, we should detect that whether newQty is more than SalesUnitMaxOrderQty and change Qty to SalesUnitMaxOrderQty
      newQty= priceListDetail[priceListDetail.length-1].SalesUnitMaxOrderQty<=newQty?priceListDetail[priceListDetail.length-1].SalesUnitMaxOrderQty:newQty
      }
      if(((firstQty==null|| !(priceListDetail.length >0)) && priceList?.HasDetailRange && mode==='edit') && ((numberOfSalesUnit==1 && newQty!==selectedObj.Qty1) ||( numberOfSalesUnit==2 && newQty!==selectedObj.Qty2))){
        setSavedNewQty(newQty) //to countinue with newQty and prevent to reset newQty
        // چون که شرط  رترن میکنه و از تابع خارج میشه مقدار جدید (نیوکیوتیوای ) ذخیره نمیشه  و مقدار قبلیشو میگیره و باید مقدار جدیدشو حفظ کنیم
        
        setFirstQty(selectedObj?.ItemId)
        fetchPriceListDetail(itemData?.Id??selectedObj?.ItemId)
      }//in create mode uses itemData and edit,view mode uses selectedObj?.ItemId
   
      if(!invoiceConstraint.IsAbsoluteUnitConversionRatio!=null &&detailPriceData.Unit1Id && detailPriceData.Unit2Id &&!invoiceConstraint.IsAbsoluteUnitConversionRatio&&QtyInChange){
        let newPriceData:any ={}
        if(QtyInChange=="Qty1"){
          if(numberOfSalesUnit==1){
            newPriceData =await calculatePriceData(newQty, priceListArray);
          }else{
            newPriceData =await calculatePriceData( detailPriceData.Qty2, priceListArray);
          }
        }else{
          if(numberOfSalesUnit==1){
            newPriceData =await calculatePriceData(detailPriceData.Qty1, priceListArray);
          }else{
            newPriceData =await calculatePriceData(newQty, priceListArray);
          }
        }
        let DetailPrice = {
          ...newPriceData,
          // TaxRate: taxRate || detailPriceData.TaxRate,
          Qty1:  RoundWithRoundingPlace(QtyInChange =="Qty1"? newQty: detailPriceData.Qty1,priceListDetail[0]?.Qty1RoundingPlace),
          Qty2:    RoundWithRoundingPlace(QtyInChange =="Qty1"? detailPriceData.Qty2 :newQty,priceListDetail[0]?.Qty2RoundingPlace) ,
        }
        
        if(newPriceData.PriceListUnitId==newPriceData.SalesUnitId  ){
          //درصورتی ک واحد فروش باواحد لیست قیمت برابر باشد از منطق قبل که قیمت واحد لیست قیمت را دست نزنیم و قیمت واحد فروش را تغییر دهیم نمیتوان استفاده کرد. و باید در این حالت واحد فروش و لیست قیمت را .که یکی هستند ثابت نگه داریم و واحد دیگر را تغییر دهیم 
          setDetailPriceData({
            ...DetailPrice,
            UnitPrice: (numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) * newPriceData.SalesUnitPrice/ (numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1),//بسازیمsaleUnitPriceوSubTotalPrice  را براساس unitPrice باید 
            SalesUnitPrice: newPriceData.SalesUnitPrice,  
            SubTotalPrice:newPriceData.SalesUnitPrice==-1?0: (numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) * newPriceData.SalesUnitPrice,
          TotalPrice:newPriceData.SalesUnitPrice==-1?0: calculateDiscountedPrice((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice: newPriceData.SalesUnitPrice ,DiscountPercent:DetailPrice.DiscountPercent}),
          Discount: calculateDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice:  newPriceData.SalesUnitPrice ,DiscountPercent:DetailPrice.DiscountPercent}),
            CustomerDiscount: calculateCusomerDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), newPriceData)
          });
        }else{
          const SalesUnitPrice=(newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2)
        setDetailPriceData({
          ...DetailPrice,
          SalesUnitPrice: SalesUnitPrice,  
          SubTotalPrice:SalesUnitPrice==-1?0: (numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) * (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2),
          TotalPrice: SalesUnitPrice==-1?0: calculateDiscountedPrice((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice:  (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) ,DiscountPercent:DetailPrice.DiscountPercent}),

        
          Discount: calculateDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice:  (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) ,DiscountPercent:DetailPrice.DiscountPercent}),
          CustomerDiscount: calculateCusomerDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice:  SalesUnitPrice}),
        });}
      }else{
        let newPriceData =await calculatePriceData(newQty, priceListArray);
       
        setDetailPriceData({
        ...newPriceData,
        Qty1:RoundWithRoundingPlace((numberOfSalesUnit === 1?1:priceListDetail[0]?.ConversionRatio)*newQty ,priceListDetail[0]?.Qty1RoundingPlace),
        Qty2: RoundWithRoundingPlace(newQty/(numberOfSalesUnit === 2?1:priceListDetail[0]?.ConversionRatio) ,priceListDetail[0]?.Qty2RoundingPlace) ,
      });

      }
  };

  const calculatePriceData = (newQty, priceListArray) => {
    const currentPriceList = !!priceListArray.length ? priceListArray : priceListDetail;
    let matchedPriceData = findMatchingPriceData(currentPriceList, newQty);
    matchedPriceData=matchedPriceData?matchedPriceData:{...currentPriceList[0],Unit2Price:0,Unit1Price:0,SalesUnitPrice:0,DiscountPercent:0,}

    return {
      ...matchedPriceData,
      UnitPrice:matchedPriceData?.UnitPrice || matchedPriceData?.UnitPrice==0?matchedPriceData?.UnitPrice: matchedPriceData?.SalesUnitId === matchedPriceData?.Unit1Id
        ? matchedPriceData?.Unit2Price
        : matchedPriceData?.Unit1Price,
    
      TotalPrice:matchedPriceData?.SalesUnitPrice==-1?0: calculateDiscountedPrice(newQty, matchedPriceData),
      GrandTotalPrice:matchedPriceData?.SalesUnitPrice==-1?0:calculateDiscountedPrice(newQty, matchedPriceData) +((((invoiceConstraint.HasTax  && mode!='view') || mode=='view'? priceList.IsManual
        ? detailPriceData.TaxRate
        : currentPriceList[0]?.TaxRate
      : 0) *calculateDiscountedPrice(newQty, matchedPriceData)) / 100),
      Discount: calculateDiscount(newQty, matchedPriceData),
      CustomerDiscount: calculateCusomerDiscount(newQty, matchedPriceData),
      //to set TaxRate when pricelist is manual then we sould use detailPriceData.TaxRate because we nedd to save taxrate when unitprice are changing and currentPriceList[0] is 0 because was set at first
      TaxRate:(docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& ((mode!='view' && invoiceConstraint.HasTax) || mode=='view' )))?priceList.IsManual?detailPriceData.TaxRate:  currentPriceList[0]?.TaxRate:0,
      DiscountPercent:priceList.IsManual?+detailPriceData.DiscountPercent:+matchedPriceData?.DiscountPercent,
      SubTotalPrice:matchedPriceData?.SalesUnitPrice==-1?0: newQty * matchedPriceData?.SalesUnitPrice,
    };
  };

  
  const findMatchingPriceData = (priceList, qty) =>
    priceList
      .find(
        (e) =>
          (e.SalesUnitMaxOrderQty == null || +e.SalesUnitMaxOrderQty >= qty) &&
          +e.SalesUnitMinOrderQty <= qty
      );

  const calculateDiscountedPrice = (qty, priceData) =>  {
        const discount=RoundWithRoundingPlace(
          (+qty *
            (+priceData?.SalesUnitPrice *
              (+priceData?.DiscountPercent))) /
            100,
          currency?.PriceRoundingPlace,
          
        );
      if(priceData.CustomerDiscountPercent!=null&&priceData.CustomerDiscountPercent!=0){  
        const customerDiscount=RoundWithRoundingPlace(
        (+qty * (+priceData?.SalesUnitPrice * ((100-priceData?.DiscountPercent)/100) )*(priceData.CustomerDiscountPercent/100)),
        currency?.PriceRoundingPlace,
        
      );
      const totalDiscount=discount+customerDiscount
        return RoundWithRoundingPlace(
                  (+qty *+priceData?.SalesUnitPrice ) -totalDiscount ,
                  currency?.PriceRoundingPlace,
                  
                );
      }else{
        return    RoundWithRoundingPlace(
          (+qty *+priceData?.SalesUnitPrice ) -discount ,
          currency?.PriceRoundingPlace,
          
        );
      }
  
    }

  const calculateDiscount = (qty, priceData) =>{
    if(priceList.IsManual){
      return RoundWithRoundingPlace(
        qty * ((priceData?.SalesUnitPrice *//استفاده از پرایس دیتا برای وقتی در حال تغییر  قیمت واحد هستیم و باید از قیمت واحد اپدیت شده و درصد تخفیف توی استیت استفاده کنیم
           ((detailPriceData?.DiscountPercent??0))) / 100),
        currency.PriceRoundingPlace,
        
      );
    }
    else{
      return RoundWithRoundingPlace(
        qty * ((priceData?.SalesUnitPrice * ( priceData?.DiscountPercent)) / 100),
        currency.PriceRoundingPlace,
        
      );
    }
  }
   const calculateCusomerDiscount = (qty, priceData) =>{

      return RoundWithRoundingPlace(
        qty * (((priceData?.SalesUnitPrice * ((100-priceData?.DiscountPercent)/100)) *//استفاده از پرایس دیتا برای وقتی در حال تغییر  قیمت واحد هستیم و باید از قیمت واحد اپدیت شده و درصد تخفیف توی استیت استفاده کنیم
           ((priceData?.CustomerDiscountPercent??0))) / 100),
        currency.PriceRoundingPlace,
        
      );
    
  }

  const fetchTaxRate =  (list) => {
    let totalTaxRate = 0;
    if(list && !!list.length){
      list.map((item) => {
        totalTaxRate += item.TaxRate;
      });
    }
    return totalTaxRate;
};

console.log( invoiceConstraint?.ItemReserving!="Invoice"?jobId:null);


const fetchPriceListDetail = async (itemId = null, code = null,warehouseId=warehouseData?.WarehouseId?warehouseData?.WarehouseId:selectedObj?.WarehouseId,warehouseDetailId=warehouseData?.WarehouseDetailId) => {
  try {
    const { Data } =
     await getPriceListDetail(
     itemId,
     priceList?.Id,
     code,
     warehouseId,
     warehouseDetailId=='noHaveWarehouseDetail'?undefined:warehouseDetailId,
     personId,
     invoiceConstraint?.ItemReserving!="Invoice"?jobId:null//اگر آیتم رزروینگ روی  فاکتور نباشه یعنی با ذخیره  فاکتور از موجودی کم نمیشه و قرار نیست ما مقدار واحد اول به موجودی اضافه کنیم پس در این حالت جاب آیدی رو برای بک میفرستیم و با فرستادن جاب آیدی بک اند موجودی اولیه رو میده بدون کم کردن هرچیزی و ما همونو مستقیم نمایش میدیم بدون تغییر. اگر ایتم رزروینگ روی  فاکتور باشه یعنی با ذخیره  فاکتور از موجودی باید کم کنیم و جاب آیدی نمیفرستیم در این حالت بک اند موجودی کم شده رو میده و ما خودمون مقدار واحد اول بهش اضافه میکنیم
      
   );

   const newPriceListDetails=Data?.ItemPriceList.map((item)=>{
    return {...item,

        ItemId: Data.ItemId,
        MainUnitId: Data.MainUnitId,
        StatisticalUnitId: Data.StatisticalUnitId,
        PriceListUnitId: Data.PriceListUnitId,
        ItemDescription:Data.ItemDescription,
        ItemDescriptionEN: Data.ItemDescriptionEN,
        ItemCode: Data.ItemCode,
        ItemTechnicalCode: Data.ItemTechnicalCode,
        HasProductTracking: Data.HasProductTracking,
        HasExpireDate: Data.HasExpireDate,
        HasSerial: Data.HasSerial,
        IsAbsoluteUnitConversionRatio: Data.IsAbsoluteUnitConversionRatio,
        ConversionRatio: Data.ConversionRatio,
        PriceRoundingPlace: Data.PriceRoundingPlace,
        Qty1RoundingPlace: Data.Qty1RoundingPlace,
        Unit2: Data.Unit2,
        Unit2EN: Data.Unit2EN,
        Qty2RoundingPlace: Data.Qty2RoundingPlace,
        ItemTaxList:Data.ItemTaxList,
        ItemStockList:Data.ItemStockList,

      SalesUnitMaxOrderQty:Data.SalesUnitId === Data.MainUnitId?item.Unit1MaxOrderQty:item.Unit2MaxOrderQty,
      SalesUnitMinOrderQty:Data.SalesUnitId === Data.MainUnitId?item.Unit1MinOrderQty:item.Unit2MinOrderQty,
      MaxOrderQty:Data.SalesUnitId === Data.MainUnitId?item.Unit2MaxOrderQty:item.Unit1MaxOrderQty,
      MinOrderQty:Data.SalesUnitId === Data.MainUnitId?item.Unit2MinOrderQty:item.Unit1MinOrderQty,
      SalesUnitPrice:Data.SalesUnitId === Data.MainUnitId?item.Unit1Price:item.Unit2Price,
      SalesUnitId:Data.SalesUnitId,
      SalesUnitDiscount:Data.SalesUnitId === Data.MainUnitId?item.Unit1Discount:item.Unit2Discount,
      Unit1Id:Data.MainUnitId,
      Unit2Id:Data.StatisticalUnitId
      //تعیین واحد فروش،کمترین و بیشترین مقدار فروش و کمترین و بیشترین مقدار واحد قیمت ، واحد اول و دوم
      //Determining the sales unit,because we use sales unit for countinuing programm and doing calculate
    }
  })
      if(Data.ItemId==selectedObj?.ItemId){
        setEditedNewId(true)
      }

   updatePriceListDetails(!!newPriceListDetails?.length?[{...newPriceListDetails[0] , TaxRate: fetchTaxRate(Data.ItemTaxList)} ,...newPriceListDetails.slice(1) ]:priceList?.IsManual?[
{
     
           
                  ItemId: Data.ItemId,
        MainUnitId: Data.MainUnitId,
        StatisticalUnitId: Data.StatisticalUnitId,
        PriceListUnitId: Data.PriceListUnitId,
        ItemDescription:Data.ItemDescription,
        ItemDescriptionEN: Data.ItemDescriptionEN,
        ItemCode: Data.ItemCode,
        ItemTechnicalCode: Data.ItemTechnicalCode,
        HasProductTracking: Data.HasProductTracking,
        HasExpireDate: Data.HasExpireDate,
        HasSerial: Data.HasSerial,
         CustomerDiscountPercent:0,
        DiscountPercent:0,
        IsAbsoluteUnitConversionRatio: Data.IsAbsoluteUnitConversionRatio,
        ConversionRatio: Data.ConversionRatio,
        PriceRoundingPlace: Data.PriceRoundingPlace,
        Qty1RoundingPlace: Data.Qty1RoundingPlace,
        Unit2: Data.Unit2,
        Unit2EN: Data.Unit2EN,
        Qty2RoundingPlace: Data.Qty2RoundingPlace,
        ItemTaxList:Data.ItemTaxList,
        ItemStockList:Data.ItemStockList,
TaxRate: await fetchTaxRate(Data.ItemTaxList),
      SalesUnitMaxOrderQty:null,
      SalesUnitMinOrderQty:0,
      MaxOrderQty:null,
      MinOrderQty:0,
      SalesUnitPrice:0,
      SalesUnitId:Data.SalesUnitId,
      SalesUnitDiscount:0,
      Unit1Id:Data.MainUnitId,
      Unit2Id:Data.StatisticalUnitId
}

    
   ]:[]);
         if(!newPriceListDetails.length && !priceList.IsManual){
 Toast(trans("Msg_InvalidPriceListItem"), MessageType.error);
      }
 } catch {
    setShowTree(true)
 }
};


  const updatePriceListDetails = async (data ,withPriceListDetail=true,useSelectedObj=false ) => {
    const [firstItem] =useSelectedObj?[selectedObj]: data;
    setNumberOfSalesUnit(firstItem?.SalesUnitId === firstItem?.Unit1Id ? 1 : 2);
    // if(mode=="create"){
      // const tax=fetchTaxRate(firstItem.ItemTaxList);
      // (docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& invoiceConstraint.HasTax)) ? setTotalTaxRate(tax):setTotalTaxRate(0)
    // }

    if(priceList.IsManual){
      //درصورتی که لیست قیمت دستی باشد چون مالیات را از استیت دیتیل پرایس دیتا میگیریم برای اینکه در مد ادیت مقدار مالیات را از دست ندهیم ، در صورتی که مد ادیت باشد یا ایجاد ابتدا مالیات را در این قسمت ست میکنیم که در توابع پایین تر بتواند محاسبات مالیات را انجام دهد.
      setDetailPriceData((prev)=>{return {...prev,TaxRate:firstItem?.TaxRate}})
    }
    setRate(firstItem?.ConversionRatio);
    if(withPriceListDetail) setPriceListDetail(data);


    setItemData({
      ...itemData,
Item: firstItem?.Item ? firstItem?.Item : firstItem?.ItemDescription?firstItem?.ItemDescription:itemData?.Item,
      ItemId: firstItem?.ItemId?firstItem?.ItemId:itemData?.ItemId,
      Code: firstItem?.ItemCode ? firstItem?.ItemCode : firstItem?.Code?firstItem?.Code:itemData?.Code,
      HasProductTracking: firstItem?.HasProductTracking,
      HasExpireDate: firstItem?.HasExpireDate,
      HasSerial: firstItem?.HasSerial,
      ItemStockList:firstItem?.ItemStockList,
    });
    //وقتی مقادیر را با مقدار قبلی آیتم دیتا پر میکنیم که به تغییر انبار یا انبار فرعی کالا در لیست کالا ها نباشد پس لیست قیمت خالی است و اطلاعات کالا را با اطلاعات قبلی پر میکنیم
    // if(mode=="create"){
      // const tax=fetchTaxRate(firstItem.ItemTaxList);
      // (docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& invoiceConstraint.HasTax)) ? setTotalTaxRate(tax):setTotalTaxRate(0)
    // }

    // setRate(firstItem?.ConversionRatio);
    // if(withPriceListDetail) setPriceListDetail(data);

    setLoadingItemStock(true)
  };

  const cancel = () => {
    if (sessionStorage.getItem('changingforms') === 'true') {
      // Toast('modalclosemessage', 'warning', 'alertWithoutClose', () => {
      //   sessionStorage.setItem('changingforms', 'false');
      //   setUserChanges({});
      //   onHide();
      // });
      Toast('modalclosemessage', MessageType.confirm, () => {
        sessionStorage.setItem('changingforms', 'false');
        setUserChanges({});
        onHide();
      });
    } else {
      onHide();
    }
  };

  useEffect(() => {
    if (resetForm) setResetForm(false);
  }, [resetForm]);

  


  const initializeFormWithSelectedObject = () => {
    setWarehouseData({
      WarehouseId: selectedObj.WarehouseId ,
      WarehouseDetailId: selectedObj?.WarehouseDetailId ,
      Title: selectedObj.WarehouseDetail
      ? `${selectedObj.Warehouse},${selectedObj.WarehouseDetail}`
      : selectedObj.Warehouse,
    });

    setDetailPriceData({...selectedObj , UnitPrice:selectedObj.SalesUnitId === selectedObj.Unit1Id ? selectedObj?.Unit2Price : selectedObj?.Unit1Price,
      TaxRate:(docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& ((mode!='view' && invoiceConstraint.HasTax) || mode=='view' ))) ?selectedObj.TaxRate:0
    })
    updatePriceListDetails([{...selectedObj,
      SalesUnitMaxOrderQty:null,
      SalesUnitMinOrderQty:0,
      MaxOrderQty:null,
      MinOrderQty:0,
      SalesUnitPrice:selectedObj.SalesUnitId === selectedObj.Unit1Id?selectedObj.Unit1Price:selectedObj.Unit2Price,
      SalesUnitId:selectedObj.SalesUnitId ,
      SalesUnitDiscount:selectedObj.Discount,
      HasProductTracking: selectedObj.HasProductTracking,
      HasExpireDate: selectedObj.HasExpireDate,
      HasSerial: selectedObj.HasSerial,
       TaxRate: (docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& (((mode!='view' && invoiceConstraint.HasTax) || mode=='view') ))) ?selectedObj.TaxRate:0,
    }] , true,true)

  };

const getItemStockListAsync=async()=>{
setLoadingItemStock(false)
  try {
    const { Data } = await getPriceListDetail(
     selectedObj?.ItemId,
      priceList?.Id,
     selectedObj?.Code,
     selectedObj?.WarehouseId,
     selectedObj?.WarehouseDetailId,
     personId,
      invoiceConstraint?.ItemReserving!="Invoice"?jobId:null//اگر آیتم رزروینگ روی  فاکتور نباشه یعنی با ذخیره  فاکتور از موجودی کم نمیشه و قرار نیست ما مقدار واحد اول به موجودی اضافه کنیم پس در این حالت جاب آیدی رو برای بک میفرستیم و با فرستادن جاب آیدی بک اند موجودی اولیه رو میده بدون کم کردن هرچیزی و ما همونو مستقیم نمایش میدیم بدون تغییر. اگر ایتم رزروینگ روی  فاکتور باشه یعنی با ذخیره  فاکتور از موجودی باید کم کنیم و جاب آیدی نمیفرستیم در این حالت بک اند موجودی کم شده رو میده و ما خودمون مقدار واحد اول بهش اضافه میکنیم
      
   );

   setItemData((prev)=>{return{...prev,ItemStockList:Data?.ItemStockList}})
   
 } catch {}
setLoadingItemStock(true)
}

  useEffect(() => {
    if (selectedObj && mode !== 'create') {
      initializeFormWithSelectedObject();
      if(((selectedObj?.HasExpireDate || selectedObj?.HasProductTracking) && mode=='edit')){
      getItemStockListAsync()}
    }
  }, []);
  useEffect(() => {
    if ( mode === 'create' &&priceListDetail.length > 0) {
      
      updateQuantity(priceListDetail[0]?.SalesUnitMinOrderQty?priceListDetail[0]?.SalesUnitMinOrderQty:1,[]);

    }
    if (mode !== 'create'&&priceListDetail.length > 0 ) {
      //first changing qty1 we should use savedQty to prevent to reset qty
      updateQuantity((selectedObj?.ItemId==itemData?.ItemId && ((selectedObj?.WarehouseDetailId==warehouseData?.WarehouseDetailId) && (selectedObj?.WarehouseId == warehouseData?.WarehouseId)))?savedNewQty??+selectedObj?.['Qty' + numberOfSalesUnit]:priceListDetail[0]?.SalesUnitMinOrderQty?priceListDetail[0]?.SalesUnitMinOrderQty:1,[]);
      //when mode is edit this fun run becuase maybe user select current item through handleItemCode
     //when mode is edit this fun run becuase maybe user select new item through handleItemCode
  
    }
  }, [priceListDetail]);



  return (
    <div className="card " style={{ flexDirection: "row" }}>
      {showTree && (
        <ModalForm
          mode={mode}
          title="ItemTree"
          onHide={() => setShowTree(false)}
          show={showTree}
        >
          <ItemsForSell
            priceListId={priceList?.Id}
            warehouseId={warehouseData?.WarehouseId}
            warehouseDetailId={warehouseData?.WarehouseDetailId}
            onHide={() => {
              setShowTree(false);
            }}
            itemCodeHandeler={handleItemCode}
            searchString={itemSearch}

          />
        </ModalForm>
      )}
      {showWarehouseTree && (
        <ModalForm
          mode={mode}
          title="warehouses"
          onHide={() => setShowWarehouseTree(false)}
          show={showWarehouseTree}
        >
          <WarehouseTreeForm
            onHide={() => {
              setShowWarehouseTree(false);
            }}
            WarehouseIdHandeler={handleWarehouseSelection}
          />
        </ModalForm>
      )}
      <div style={{flexWrap:"nowrap"}} className="card-body row">
        <div
          className={`card-body ${
            !!priceListDetail.length
              ? "col-12 col-md-7 col-lg-8 col-xl-9"
              : "col-12"
          }`}
        >
          {loading ? (
            <div className="container-fluid">
              <form onSubmit={handleSalesInvoiceFormSubmit}>
              <ItemSelector mode={mode} resetForm={resetForm} setWarehouseData={setWarehouseData} 
                setDetailPriceData={setDetailPriceData}
                fetchPriceListDetail={fetchPriceListDetail }
                setUserChanges={(e)=>{setUserChanges({ ...userChanges, ...e })}}
                setShowTree={setShowTree} 
                setItemData={setItemData} 
                warehouseData={warehouseData}
                detailPriceData={detailPriceData} 
                itemData={itemData}
                setItemSearch={setItemSearch}
                showTree={showTree}
                />

              <PriceFields mode={mode} resetForm={resetForm} 
                setUserChanges={(e)=>{setUserChanges({ ...userChanges, ...e })}}
                numberOfSalesUnit={numberOfSalesUnit} 
                priceList={priceList}
                 priceListDetail={priceListDetail} 
                 currency={currency} 
                 Constraint={invoiceConstraint}
                 rate={rate}
                 setRate={setRate}
                  detailPriceData={detailPriceData} 
                  setPriceListDetail={setPriceListDetail}
                  updateQuantity={updateQuantity}
                   setDictionaryName={setDictionaryName}/>
                <div className="row justify-content-lg-end">
                  <div className=" col-lg-2 col-11">
                    {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="DiscountPercent"
                      textboxType="text"
                      useTrans={false}
                      labelText={trans("DiscountPercent")+'%'}
                      value={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData?.DiscountPercent + ""
                          : 0
                      }
                      onChange={(e) =>
                        setDetailPriceData({
                          ...detailPriceData,
                          DiscountPercent: +e.target.value,
                          Discount:
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                            100,
                            TotalPrice:
                            detailPriceData?.SubTotalPrice -
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                              100,
                        })
                      }
                      defaultValue={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData.DiscountPercent + ""
                          : detailPriceData.DiscountPercent == 0
                          ? "0"
                          : "0"
                      }
                      resetForm={resetForm}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      useGroupingPrice={true}
                      required={false}
                      max={100}
                    /> */}
                    <PriceInput
                    Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      name="DiscountPercent"
                      useTrans={false}
                      label={trans("DiscountPercent")+'%'}
                      value={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData?.DiscountPercent + ""
                          : 0
                      }
                      onChange={(e) =>
                    {
                          setDetailPriceData({
                          ...detailPriceData,
                          DiscountPercent: +e.target.value,
                          GrandTotalPrice:
                          ( detailPriceData?.SubTotalPrice -
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                              100) +((detailPriceData.TaxRate *( detailPriceData?.SubTotalPrice -
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                              100))/100),
                          Discount:
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                            100,
                            TotalPrice:
                            detailPriceData?.SubTotalPrice -
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                              100,
                        })
                    }
                      }
                      defaultValue={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData.DiscountPercent + ""
                          : detailPriceData.DiscountPercent == 0
                          ? "0"
                          : "0"
                      }
                      resetForm={resetForm}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      required={false}
                      max={100}
                    
                    />
                  </div>
                  <div className=" col-lg-3 col-11">
                    {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="Discount"
                      textboxType="text"
                      labelText="Discount"
                      value={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : 0
                      }
                      defaultValue={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : "0"
                      }
                      resetForm={resetForm}
                      decimals={currency.PriceRoundingPlace}
                      round={false}
                      onChange={(e) => {
                        setDetailPriceData({
                          ...detailPriceData,
                          TotalPrice:
                            detailPriceData?.SubTotalPrice -
                            +e.target.value.replaceAll(",", ""),
                          GrandTotalPrice:
                            detailPriceData?.SubTotalPrice -
                            +e.target.value.replaceAll(",", ""),
                          Discount: +e.target.value.replaceAll(",", ""),
                          DiscountPercent:
                            (+e.target.value.replaceAll(",", "") /
                              detailPriceData?.SubTotalPrice) *
                            100,
                        });
                      }}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      useGroupingPrice={true}
                      required={false}
                    /> */}

                    <PriceInput
                         Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                     name="Discount"
                      label="Discount"
                      value={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : 0
                      }
                      defaultValue={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : "0"
                      }
                      resetForm={resetForm}
                      decimals={currency.PriceRoundingPlace}
                      round={false}
                      onChange={(e) => {
                        
                        setDetailPriceData({
                          ...detailPriceData,
                          TotalPrice:
                            detailPriceData?.SubTotalPrice -
                            +e.target.value.replaceAll(",", ""),
                        GrandTotalPrice:
                          ( detailPriceData?.SubTotalPrice -
                            +e.target.value.replaceAll(",", "")) +((detailPriceData.TaxRate *(detailPriceData?.SubTotalPrice -
                            +e.target.value.replaceAll(",", "")))/100),
                          Discount: +e.target.value.replaceAll(",", ""),
                          DiscountPercent:
                            (+e.target.value.replaceAll(",", "") /
                              detailPriceData?.SubTotalPrice) *
                            100,
                        });
                      }}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      required={false}
                    />
                  </div>
                </div>
               
                {(detailPriceData?.CustomerDiscountPercent &&detailPriceData.CustomerDiscountPercent !=0 )?
                      <div className="row justify-content-end">
                       
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="Price2"
                          textboxType="text"
                          labelText="totalprice"
                          value={
                            detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          defaultValue={detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={ "view"   }
                          useGroupingPrice={true}

                        /> */}
                        <PriceInput
                             Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="Price2"
                          label="totalprice"
                          value={
                            detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          defaultValue={detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={ "view"   }

                        />
                      </div>
                      <div className="w-100"></div>
                        <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CustomerDiscountPercent"
                          textboxType="number"
                          customClass={'arrow-none'}
                          useTrans={false}
                          labelText={trans("CustomerDiscountPercent")+'%'}
                          value={priceListDetail[0]?.CustomerDiscountPercent + ""}
                          max={100}
                          min={0}
                          defaultValue={
                            priceListDetail[0]?.CustomerDiscountPercent
                              ? priceListDetail[0].CustomerDiscountPercent + ""
                              : priceListDetail[0]?.CustomerDiscountPercent == 0
                              ? "0"
                              : ""
                          }
                          resetForm={resetForm}
                          mode={ "view"}
                        />
                      </div>
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CustomerDiscount"
                          textboxType="text"
                          labelText="CustomerDiscount" 
                          value={detailPriceData.CustomerDiscount}
                          defaultValue={detailPriceData.CustomerDiscount}
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={"view" }
                          useGroupingPrice={true}
                        /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="CustomerDiscount"
                          label="CustomerDiscount" 
                          value={detailPriceData.CustomerDiscount}
                          defaultValue={detailPriceData.CustomerDiscount}
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={"view" }
                        />
                      </div>
                      </div>:''
                      }
                <div className="row justify-content-end">
                <div className="col-lg-3">
                {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="TotalPrice"
                      textboxType="text"
                      labelText="totalprice"
                      value={detailPriceData.TotalPrice + ""}
                      defaultValue={
                        detailPriceData?.TotalPrice ? detailPriceData.TotalPrice : 0
                      }
                      decimals={currency.PriceRoundingPlace}
                      round={false}
                      resetForm={resetForm}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      useGroupingPrice={true}
                      required={false}
                    /> */}
                    <PriceInput
                       Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      name="TotalPrice"
                      label="totalprice"
                      value={detailPriceData.TotalPrice + ""}
                      defaultValue={
                        detailPriceData?.TotalPrice ? detailPriceData.TotalPrice : 0
                      }
                      decimals={currency.PriceRoundingPlace}
                      round={false}
                      resetForm={resetForm}
                      mode={
                     "view" 
                      }

                      required={false}
                    />
                  </div>
                  </div>
                  
          {((mode!='view' && invoiceConstraint.HasTax) || mode=='view' ) && (docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null)) && 
          <div className="row justify-content-lg-end">
          <div className=" col-lg-2 col-11">
       {/* <Textbox
         Change={(e) => {
           setUserChanges({ ...userChanges, ...e });
         }}
         textboxName="TaxRate"
         textboxType="text"
         useTrans={false}
         labelText={trans('TaxRate')+'%'}
         value={
          ((mode=='create' && invoiceConstraint.HasTax) || mode!='create' ) &&   detailPriceData?.TaxRate
             ? detailPriceData?.TaxRate + ""
             : 0
         }
         defaultValue={
          ((mode=='create' && invoiceConstraint.HasTax) || mode!='create' ) &&  detailPriceData?.TaxRate
             ? detailPriceData?.TaxRate
             : "0"
         }
         resetForm={resetForm}
         mode={
           "view"
         }
         useGroupingPrice={true}
         required={false}
         max={100}
       /> */}
       <PriceInput
           Change={(e) => {
           setUserChanges({ ...userChanges, ...e });
         }}
         name="TaxRate"
         useTrans={false}
         label={trans('TaxRate')+'%'}
         value={
          ((mode!='view' && invoiceConstraint.HasTax) || mode=='view' ) &&   detailPriceData?.TaxRate
             ? detailPriceData?.TaxRate + ""
             : 0
         }
         defaultValue={
          ((mode!='view' && invoiceConstraint.HasTax) || mode=='view' ) &&  detailPriceData?.TaxRate
             ? detailPriceData?.TaxRate
             : "0"
         }
         resetForm={resetForm}
         mode={
           "view"
         }
         required={false}
         max={100}
       />
     </div>
       <div className="col-lg-3 col-11">
         {/* <Textbox
           Change={(e) => {
             setUserChanges({ ...userChanges, ...e });
           }}
           useGroupingPrice
           textboxName="Tax"
           textboxType="text"
           labelText="Tax"
           decimals={currency.PriceRoundingPlace}
           defaultValue={
            ((mode=='create' && invoiceConstraint.HasTax) || mode!='create' ) && detailPriceData?.TaxRate
               ? invoiceConstraint?.FloorTaxDuty ?
               FloorWithRoundingPlace(
                 (+detailPriceData.TaxRate *
                   +detailPriceData?.TotalPrice) /
                   100,
                 currency.PriceRoundingPlace,
                 
               ) + ""
               :RoundWithRoundingPlace(
                   (+detailPriceData.TaxRate *
                     +detailPriceData?.TotalPrice) /
                     100,
                   currency.PriceRoundingPlace,
                   
                 ) + ""
               : "0"
           }
           value={
            ((mode=='create' && invoiceConstraint.HasTax) || mode!='create' )&&   detailPriceData?.TaxRate
               ?invoiceConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                 (+detailPriceData?.TaxRate *
                   +detailPriceData?.TotalPrice) /
                   100,
                 currency.PriceRoundingPlace,
                 
               ) + "": RoundWithRoundingPlace(
                   (+detailPriceData?.TaxRate *
                     +detailPriceData?.TotalPrice) /
                     100,
                   currency.PriceRoundingPlace,
                   
                 ) + ""
               : "0"
           }
           resetForm={resetForm}
           mode={
            "view"
           }
           required={false}
           // onChange={(e) => {
           //   if (priceList.IsManual) {
           //     setDetailPriceData({
           //       ...detailPriceData,
           //       TaxRate:
           //         (+e.target.value.replaceAll(",", "") * 100) /
           //         detailPriceData.TotalPrice,
           //     });
           //   }
           // }}
         /> */}
         <PriceInput
             Change={(e) => {
             setUserChanges({ ...userChanges, ...e });
           }}
           name="Tax"
           label="Tax"
           decimals={currency.PriceRoundingPlace}
           defaultValue={
            ((mode!='view' && invoiceConstraint.HasTax) || mode=='view' ) && detailPriceData?.TaxRate
               ? invoiceConstraint?.FloorTaxDuty ?
               FloorWithRoundingPlace(
                 (+detailPriceData.TaxRate *
                   +detailPriceData?.TotalPrice) /
                   100,
                 currency.PriceRoundingPlace,
                 
               ) + ""
               :RoundWithRoundingPlace(
                   (+detailPriceData.TaxRate *
                     +detailPriceData?.TotalPrice) /
                     100,
                   currency.PriceRoundingPlace,
                   
                 ) + ""
               : "0"
           }
           value={
            ((mode!='view' && invoiceConstraint.HasTax) || mode=='view' )&&   detailPriceData?.TaxRate
               ?invoiceConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                 (+detailPriceData?.TaxRate *
                   +detailPriceData?.TotalPrice) /
                   100,
                 currency.PriceRoundingPlace,
                 
               ) + "": RoundWithRoundingPlace(
                   (+detailPriceData?.TaxRate *
                     +detailPriceData?.TotalPrice) /
                     100,
                   currency.PriceRoundingPlace,
                   
                 ) + ""
               : "0"
           }
           resetForm={resetForm}
           mode={
            "view"
           }
           required={false}
           // onChange={(e) => {
           //   if (priceList.IsManual) {
           //     setDetailPriceData({
           //       ...detailPriceData,
           //       TaxRate:
           //         (+e.target.value.replaceAll(",", "") * 100) /
           //         detailPriceData.TotalPrice,
           //     });
           //   }
           // }}
         />
       </div>
     </div>
                
                }
                <div className="row justify-content-lg-end">
                  <div className="col-lg-3 col-11">
                    {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="GrandTotalPrice"
                      textboxType="text"
                      labelText="payableamount"
                      value={detailPriceData.GrandTotalPrice }
                      defaultValue={detailPriceData.GrandTotalPrice }
                      resetForm={resetForm}
                      decimals={currency.PriceRoundingPlace}
                      round={false}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      useGroupingPrice={true}
                      required={false}
                    /> */}
                    <PriceInput
                                        Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      name="GrandTotalPrice"
                      label="payableamount"
                      value={detailPriceData.GrandTotalPrice }
                      defaultValue={detailPriceData.GrandTotalPrice }
                      resetForm={resetForm}
                      decimals={currency.PriceRoundingPlace}
                      round={false}
                      mode={
                      "view"
                      }
     
                      required={false}
                    />
                  </div>
                </div>

                <div className="row justify-content-end">
                  {/* {detailPriceData.HasProductTracking && (
                    <>
                      <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxType="text"
                          textboxName="PartyNo"
                          labelText="PartyNo"
                          defaultValue={
                            mode != "create" ? selectedObj?.PartyNo : null
                          }
                          resetForm={resetForm}
                          mode={mode}
                          required={false}
                        />
                      </div>
                      <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CargoWeight"
                          textboxType="number"
                          labelText="CargoWeight"
                          defaultValue={
                            mode != "create" ? selectedObj?.CargoWeight : null
                          }
                          resetForm={resetForm}
                          mode={mode}
                          required={false}
                        />
                      </div>
                    </>
                  )}
                  {detailPriceData.HasExpireDate && (
                    <div className="col-lg-2">
                      <Datepicker
                        mode={mode}
                        lable="ExpireDate"
                        setIsoTime={(isoTime: string) => {
                          setExpireDate(isoTime);
                        }}
                        val={mode != "create" ? selectedObj?.ExpireDate : null} //resetForm ? new Date().toISOString() :
                        errorFlag={false}
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        resetForm={resetForm}
                        required={false}
                      />
                    </div>
                  )} */}


        {((((itemData?.HasProductTracking ||
              itemData?.HasExpireDate) && itemData?.ItemStockList?.length>0) && loadingItemStock ) || (mode!='create' && detailPriceData?.ExpireDate && detailPriceData?.PartyNo)) && (
        <>

        <div className="col-lg-7">
                  <ItemStockList
                    sendDataCallBack={(obj) => setItemStokList(obj)}
                    defaultValue={detailPriceData}
                    data={itemData}
                    mode={mode}
                    initialStock={initialStock}
                    useCalculateItemStock={invoiceConstraint?.ItemReserving=="Invoice"}//اگر ایتم رزروینگ روی  فاکتور باشه یعنی با ذخیره  فاکتور از موجودی کم میشه پس با باز شدن فرم باید به موجودی کم شده ای که بک میده مقدار واحد اول اضافه کنیم و موجودی اولیه بشه تا به کاربر نشون بدیم . و اگر آیتم رزروینگ روی  فاکتور نباشه با ذخیره از موجودی کم نمیکنیم و موجودی اولیه رو میگیریم و نباید تغییرش بدیم
                  
                  />
                </div>
        
        
         <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CargoWeight"
                          textboxType="number"
                          labelText="CargoWeight"
                          defaultValue={
                            mode != "create" ? selectedObj?.CargoWeight : null
                          }
                          resetForm={resetForm}
                          mode={mode}
                          required={false}
                        />
                      </div>
        </>        
                
              )}



                  <div className="col-12">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxType="textarea"
                      textboxName="Description"
                      minHeight={1}
                      labelText="Remarks"
                      defaultValue={
                        mode != "create" ? selectedObj?.Description : null
                      }
                      resetForm={resetForm}
                      mode={mode}
                      required={false}
                      maxLength={150}
                    letterCounter={true}
                    />
                  </div>
                </div>
                <>
                  {mode != "view" ? (
                    <div className="col-lg-12 mt-1 btns_form">
                  {  mode ==='create' &&  <Button value="save" btnType="submit" />}
                      <Button
                        value="SaveAndClose"
                        btnType="submit"
                        onClick={() => {
                          setSaveExit(true);
                        }}
                      />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-12 mt-1 btns_form">
                      <Button
                        btnType="primary"
                        value="close"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  )}
                </>
              </form>
            </div>
          ) : (
            <Loading />
          )}
        </div>
        {(!!priceListDetail.length && (priceList?.HasDetailRange &&(mode==='create' || (mode==='edit' &&showPriceListDetail))) ) &&(
          <PriceDetails constraint={invoiceConstraint} priceListDetail={priceListDetail} />
        )}
      </div>
    </div>
  );
};
